import { all, takeLatest } from 'redux-saga/effects';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { fetchReducerActions, createFetchAction, createSaga, fetchInitialState } from 'store/utils';
import * as dashbaordApi from 'api/dashboard';

export const fetch_schedule = createFetchAction('fetch_schedule');
export const fetch_project_graph = createFetchAction('fetch_project_graph');
export const fetch_sales_graph = createFetchAction('fetch_sales_graph');
export const fetch_updated_projects = createFetchAction('fetch_updated_projects');
export const fetch_product_data = createFetchAction('fetch_product_data');
export const fetch_layout = createFetchAction('fetch_layout');
export const edit_layout = createFetchAction('edit_layout');
export const fetch_milling_notification = createFetchAction('fetch_milling_notification');
export const fetch_scan_patients = createFetchAction('fetch_scan_patients');
export const fetch_latest_projects = createFetchAction('fetch_latest_projects');

interface InitialState {
  uiDraggable: boolean;
  schedule: object | any;
  projectGraph: object | any;
  salesGraph: object | any;
  updatedProjects: object | any;
  productData: object | any;
  layout: object | any;
  editLayout: object | any;
  millingNotification: object | any;
  scanPatients: object | any;
  latestProjects: object | any;
}

const initialState: InitialState = {
  uiDraggable: false,
  schedule: { ...fetchInitialState, data: null },
  projectGraph: { ...fetchInitialState, data: null },
  salesGraph: { ...fetchInitialState, data: null },
  updatedProjects: { ...fetchInitialState, data: null },
  productData: { ...fetchInitialState, data: null },
  layout: { ...fetchInitialState, data: null },
  editLayout: { ...fetchInitialState },
  millingNotification: { ...fetchInitialState },
  scanPatients: { ...fetchInitialState, data: null },
  latestProjects: { ...fetchInitialState, data: null },
};

const slice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {
    toggle_ui_draggable: (state, { payload }: PayloadAction<boolean>) => {
      state.uiDraggable = payload;
    },
    ...fetchReducerActions(fetch_schedule, 'schedule'),
    ...fetchReducerActions(fetch_project_graph, 'projectGraph'),
    ...fetchReducerActions(fetch_sales_graph, 'salesGraph'),
    ...fetchReducerActions(fetch_updated_projects, 'updatedProjects'),
    ...fetchReducerActions(fetch_product_data, 'productData'),
    ...fetchReducerActions(fetch_layout, 'layout'),
    ...fetchReducerActions(edit_layout, 'editLayout'),
    ...fetchReducerActions(fetch_milling_notification, 'millingNotification'),
    ...fetchReducerActions(fetch_scan_patients, 'scanPatients'),
    ...fetchReducerActions(fetch_latest_projects, 'latestProjects'),
  },
});

export const actions: any = slice.actions;

export function* dashboardSaga() {
  yield all([
    takeLatest(
      actions.fetch_schedule_request,
      createSaga(actions, 'fetch_schedule', dashbaordApi.fetchSchedule),
    ),
    takeLatest(
      actions.fetch_project_graph_request,
      createSaga(actions, 'fetch_project_graph', dashbaordApi.fetchProjectGraph),
    ),
    takeLatest(
      actions.fetch_sales_graph_request,
      createSaga(actions, 'fetch_sales_graph', dashbaordApi.fetchSalesGraph, {
        // isApiLoading: false
      }),
    ),
    takeLatest(
      actions.fetch_updated_projects_request,
      createSaga(actions, 'fetch_updated_projects', dashbaordApi.fetchUpdatedProjects, {
        isApiLoading: false,
      }),
    ),
    takeLatest(
      actions.fetch_product_data_request,
      createSaga(actions, 'fetch_product_data', dashbaordApi.fetchProductData, {
        isApiLoading: false,
      }),
    ),
    takeLatest(
      actions.fetch_layout_request,
      createSaga(actions, 'fetch_layout', dashbaordApi.fetchLayout),
    ),
    takeLatest(
      actions.edit_layout_request,
      createSaga(actions, 'edit_layout', dashbaordApi.editLayout, {
        isAlertSuccess: true,
      }),
    ),
    takeLatest(
      actions.fetch_milling_notification_request,
      createSaga(actions, 'fetch_milling_notification', dashbaordApi.fetchMillingNotification),
    ),

    takeLatest(
      actions.fetch_scan_patients_request,
      createSaga(actions, 'fetch_scan_patients', dashbaordApi.fetchScanPatients),
    ),

    takeLatest(
      actions.fetch_latest_projects_request,
      createSaga(actions, 'fetch_latest_projects', dashbaordApi.fetchLatestProjects),
    ),
  ]);
}

export default slice.reducer;
